import { ComparisonOperator } from "./types";

export const DATE_OPERATOR_KEYS: Record<ComparisonOperator, string> = {
  eq: "dateOperatorEq",
  gt: "dateOperatorGt",
  gte: "dateOperatorGte",
  lt: "dateOperatorLt",
  lte: "dateOperatorLte",
};

export const NUMERIC_OPERATOR_KEYS: Record<ComparisonOperator, string> = {
  eq: "numericOperatorEq",
  gt: "numericOperatorGt",
  gte: "numericOperatorGte",
  lt: "numericOperatorLt",
  lte: "numericOperatorLte",
};
